import '@shoelace-style/shoelace/dist/components/spinner/spinner.js';
import '@shoelace-style/shoelace/dist/components/progress-ring/progress-ring.js';

import {css} from 'lit';
import {unsafeCSSIcon} from "../../../styles/icons";

export const styles =
    css`
        .time-nav {
            height: 30px;
            position: absolute;
            right: 5px;
            bottom: 50px;
            left: 5px;
            z-index: 99;
        }

        .time-nav a {
            position: absolute;
            top: 0;
            width: 40px;
            height: 30px;
            background-position: center center;
            background-size: 16px auto;
            background-repeat: no-repeat;
            cursor: pointer;
        }

        .time-nav a.left {
            left: 0;
            background-image: url(${unsafeCSSIcon('angle-left-thin', {size: 'x128', color: 'grey-dark'})});
        }

        .time-nav a.right {
            right: 0;
            background-image: url(${unsafeCSSIcon('angle-right-thin', {size: 'x128', color: 'grey-dark'})});
        }

        .time-nav a.disabled {
            opacity: 0.2;
        }

        .time-nav .title {
            position: absolute;
            top: 0;
            left: 50px;
            right: 50px;
            height: 30px;
            text-align: center;
            line-height: 30px;
        }

        .buttons {
            display: flex;
            position: absolute;
            right: 15px;
            bottom: 10px;
            left: 15px;
            height: 30px;
            gap: 10px;
        }

        .filter-button {
            height: 30px;
        }

        #period-select, #field-select {
            flex: 1 0 0;
            min-width: 0;
            height: 30px;
        }

        .time-buttons {
            height: 30px;
            position: absolute;
            right: 5px;
            bottom: 10px;
            left: 5px;
            margin: 0;
            padding: 0;
            list-style-type: none;
            z-index: 99;
        }

        .time-buttons li {
            display: block;
            float: left;
            width: 25%;
            height: 30px;
            box-sizing: border-box;
            padding: 0 5px;
        }

        .time-buttons li a {
            display: block;
            width: 100%;
            height: 30px;
            line-height: 30px;
            text-align: center;
            color: #fff;
            box-sizing: border-box;
            border-radius: 3px;
            text-transform: uppercase;
            background-color: var(--sp-button-background-color);
            cursor: pointer;
        }

        .time-buttons li a.selected {
            background-color: #333432;
        }
    `;
